module.exports = __webpack_public_path__ + "img/logo.d114629e.png";